import { useSubscriptionForm } from "../chunks/nsSubscriptionForm";

export const useModal = () => {
    const $body = document.querySelector(".js-ns-body");
    const $overlay = document.querySelector(".js-ns-modal-overlay");
    const modals = document.querySelectorAll(".js-ns-modal");
    const openElements = document.querySelectorAll("[data-modal-target]");

    const { handleOpenSubscriptionForm, handleCloseSubscriptionForm } =
        useSubscriptionForm();

    const runOpenCallbacks = ({ $modal }) => {
        const id = $modal.id;
        const callbacks = { "subscription-form": handleOpenSubscriptionForm };
        const fn = callbacks[id];

        if (!fn) {
            return;
        }

        fn({ $modal });
    };

    const runCloseCallbacks = ({ $modal }) => {
        const id = $modal.id;
        const callbacks = { "subscription-form": handleCloseSubscriptionForm };
        const fn = callbacks[id];

        if (!fn) {
            return;
        }

        fn({ $modal });
    };

    const openModal = ($el) => {
        const selector = $el.dataset.modalTarget;
        const $target = document.querySelector(selector);

        if (!$target) {
            return;
        }

        $target.classList.add("active");
        $overlay.classList.add("active");
        $body.classList.add("ns-prevent-scroll");

        runOpenCallbacks({ $modal: $target });
    };

    const closeModal = ($el) => {
        $overlay.classList.remove("active");
        $body.classList.remove("ns-prevent-scroll");

        $el.classList.remove("active");

        runCloseCallbacks({ $modal: $el });
    };

    const init = () => {
        openElements.forEach(($el) => {
            $el.addEventListener("click", () => openModal($el));
        });

        modals.forEach(($modal) => {
            const $close = $modal.querySelector(".js-ns-modal-close");

            $close.addEventListener("click", () => closeModal($modal));
        });
    };

    const initModals = () => {
        if (!modals || modals.length === 0) {
            return;
        }

        init();
    };

    return {
        initModals,
    };
};
